import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section8: FC = () => {
  return (
    <L_Section6>
      <Strong>
        <strong>각 분야 최고의 강사님들을</strong>
        <br />
        <strong>만날 수 있습니다.</strong>
      </Strong>
      <Mid>
        <span>기업 교육 전문 강사부터</span>
        <br />
        <span>컨설턴트, 현직에 있는 실무자까지</span>
        <br />
        <span>모두 클래스유에 있습니다.</span>
      </Mid>
      <div style={{ margin: '5rem 0 0 0' }}>
        <img
          style={{ maxWidth: '66rem', width: '100%' }}
          src="/new/biz/logos/section6.png"
          alt="teachers"
        />
      </div>
    </L_Section6>
  );
};
const Mid = styled.div`
  margin-top: 4rem;
  & > span {
    font-weight: 300;
    font-size: 1.6rem;
    color: ${palette.grey50};
  }
`;
const Strong = styled.div`
  color: ${palette.grey75};
  & > strong {
    font-size: 2.4rem;
    font-weight: 600;
  }
`;
const L_Section6 = styled.section`
  padding-top: 10rem;
  * {
    text-align: center;
    white-space: nowrap;
  }
`;

export default Section8;
